import {Observable} from 'rxjs/Observable';
import { EventEmitter } from '@angular/core';

// Classes.
import {ViewData} from './view-data';
import {WCupSeasonItem} from '../fetching/types/wcup-season.item';
import {DataContainer} from '../db/data-container';
import {ResponseData} from '../fetching/wa-response/wa-api-response';

// Providers.
import {LoggerService} from '../logger/logger-service';
import {DataFetchService} from '../wa-services/data-fetch-service';
import {DatabaseService} from '../wa-services/database-service';
import {FactoryService} from '../wa-services/factory-service';

// Interfaces.
import {LocatorInterface} from '../interfaces/locator.interface';
import {ViewDataConfigStruct} from '../interfaces/view-data.interface';

export class WCupSeasonVD extends ViewData<WCupSeasonItem> {

  public seasonChangedStream: EventEmitter<WCupSeasonItem>;


  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected factory: FactoryService,
    protected _locator: LocatorInterface

  ) {
    super(logger, db, _locator);
    this.seasonChangedStream = new EventEmitter();
  }

  public configureView() {
    let viewDataConf = new ViewDataConfigStruct();
    // Max age: 4 hours.
    viewDataConf.maxAge = 14400;
    viewDataConf.expectedItems = 1;
    this.applyConfiguration(viewDataConf);
  }

  public updateData(): Observable<ResponseData> {
    return this.fetchSrvc.requestWCupSeason(this.pageInfo());
  }

  public mapItem(rawItem: any): WCupSeasonItem {
    return this.factory.newWCupSeasonItem(rawItem);
  }

  public postMapItemsDataContainerProcess(dataContainer: DataContainer<WCupSeasonItem>): void {
    let wCupSeasonData =  dataContainer.getPayload();
    if (wCupSeasonData && wCupSeasonData.length) {
      this.seasonChangedStream.emit(wCupSeasonData[0]);
    }
  };
}
